import {
    PRINT_DONE,
    PRINT_SHOW,
    type PrintActionTypes,
    type PrintState,
} from "../../Actions/Print/PrintActions";

function PrintReducer(
    state: PrintState | undefined,
    action: PrintActionTypes
): PrintState {
    if(typeof state === "undefined") {
        return {
            print     : false,
            system    : false,
            onComplete: false,
        };
    }

    switch(action.type) {
        case PRINT_SHOW:
            return {
                print     : action.content,
                system    : action.system,
                onComplete: action.onComplete,
            };
        case PRINT_DONE:
            return {
                print     : false,
                system    : false,
                onComplete: false,
            };
        default:
            return state;
    }
}

export default PrintReducer;
